import React from "react";
import { classNames } from "@root/_utils";

type BannerProps = {
  status: string;
  className?: string;
  children: React.ReactNode;
};

const Banner = ({
  status,
  className,
  children,
}: BannerProps): React.JSX.Element => {

  const bannerClassNames = classNames(
    "gc__banner",
    `gs__class-banner_state_${status}`,
    className,
  );

  return (
    <div className={bannerClassNames} style={{ display: "block" }}>
      {children}
    </div>
  );
};

export default Banner;
